function Support() {
    return (
        <div className="App">
            <header className="App-header">
                <p>
                    For support demand you can contact me at:<br/>
                    <br/>
                    <span>loufi.officiel@gmail.com</span><br/>
                    <br/>
                    I will be happy to help you.
                </p>
            </header>
        </div>
    );
}

export default Support;
